<template>
  <section class="section">
    <nav class="level is-vcentered">
      <div class="level-left">
        <div class="level-item">
          <img class="level-item-img" src="@/assets/icon/dashboard-level.png" alt="Dashboard">
          <h1 class="title">Dashboard</h1>
        </div>
      </div>
    </nav>
    <div class="inner-section">
      <div class="container">
        <div class="column is-12">
          <div class="level">
            <div class="level-left" />
            <div class="level-right">
              <div class="level-item">
                <div class="field field_calendar">
                  <div class="control has-icons-right">
                    <v-date-picker
                      class="input_calendar"
                      clearable
                      is-range
                      mode='range'
                      v-model='dateGraphics'
                      name="dateGraphics"
                      :input-props='{ placeholder: "Rango de Fecha" }'
                    />
                    <span class="icon is-right">
                      <img class="icon_calendar" src="@/assets/icon/calendar.png">
                    </span>
                  </div>
                </div>
              </div>
              <div class="level-right has-text-centered-mobile">
                <button
                  class="button button_ibs is-rounded sm_btn"
                  :class="{'is-loading': loading}"
                  :disabled="!this.dateGraphics"
                  @click="getDataDashboardByDate"
                >
                  Filtrar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline">
          <template v-if="dashboard.length !== isEmpty">
            <!-- Socio -->
            <div class="column is-6" v-if="dataPartnerServices && !loading">
              <div class="box">
                <div class="columns is-multiline is-centered">
                  <div class="column is-12">
                    <h2 class="subtitle">
                      Servicios por Mes
                    </h2>
                    <bulma-chart
                      v-if="dataPartnerServices && dataPartnerServices.labels.length > 0"
                      :typeChart="bars"
                      :dataChart="dataPartnerServices"
                      :optionsChart="optionsChartBars"
                    />
                    <p v-else>Sin Información</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Cliente -->
            <div class="column is-6" v-if="dataCustomerService && !loading">
              <div class="box">
                <div class="columns is-multiline is-centered">
                  <div class="column is-12">
                    <h2 class="subtitle">
                      Servicios por Mes
                    </h2>
                    <bulma-chart
                      v-if="dataCustomerService && dataCustomerService.labels.length > 0"
                      :typeChart="lineStacked"
                      :dataChart="dataCustomerService"
                      :optionsChart="optionsChartLineStacked"
                    />
                    <p v-else>Sin Información</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Socios -->
            <div v-if="dataCustomerServicePartner && !loading" class="column is-6">
              <div class="box max_h">
                <h2 class="subtitle">
                  Total De Servicios por Clientes
                </h2>
                <bulma-chart
                  v-if="dataCustomerServicePartner && dataCustomerServicePartner.labels.length > 0"
                  :typeChart="pieChart"
                  :dataChart="dataCustomerServicePartner"
                  :optionsChart="{}"
                />
                <p v-else>Sin Información</p>
              </div>
            </div>
            <!-- Clientes -->
            <div v-if="dataCustomerServicesPercentage && !loading" class="column is-6">
              <div class="box max_h">
                <h2 class="subtitle">
                  Total De Servicios
                </h2>
                <bulma-chart
                  v-if="dataCustomerServicesPercentage && dataCustomerServicesPercentage.labels.length > 0"
                  :typeChart="pieChart"
                  :dataChart="dataCustomerServicesPercentage"
                  :optionsChart="{}"
                />
                <p v-else>Sin Información</p>
              </div>
            </div>
            <div class="column is-12">
              <div class="box">
                <div class="columns is-multiline is-centered">
                  <div class="column is-12">
                    <h2 class="subtitle">
                      {{userType === typePartner ? 'Servicios' : 'Últimos 5 Servicios' }}
                    </h2>
                  </div>
                  <div class="column is-8" v-if="userType === typePartner">
                    <div class="columns is-multiline is-vcentered">
                      <div class="column is-3">
                        <v-select
                          class="input_select"
                          label="name"
                          placeholder='Filtros'
                          v-model="filterSelected"
                          :reduce="filter => filter.id"
                          :options="filterList"
                          @input="setFilter"
                        >
                        </v-select>
                      </div>
                      <div class="column is-3" v-if="filterType === 'search'">
                        <div class="field">
                          <div class="control has-icons-right">
                            <input
                              class="input is-rounded input_ibs"
                              type="text"
                              placeholder="Buscar"
                              v-model="searchText"
                            >
                            <span class="icon is-right">
                              <img class="icon_search" src="@/assets/icon/search.png">
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- Select -->
                      <div class="column is-3"  v-if="filterType === 'list'">
                        <v-select
                          class="input_select"
                          label="name"
                          :placeholder='labelSelected'
                          v-model="currentValueOfTheSelect"
                          :reduce="data => data.id"
                          :options="selectedFilterData"
                        >
                        <!-- @input="setStatus" -->
                        </v-select>
                      </div>
                      <div class="column is-3" v-if="filterType === 'rangedate'">
                        <div class="field field_calendar">
                          <div class="control has-icons-right" :class="{ 'is-danger-calendar': vverrors.has('date') }">
                            <v-date-picker
                              class="input_calendar"
                              clearable
                              is-range
                              mode='range'
                              v-model='date'
                              name="date"
                              :input-props='{ placeholder: labelSelected }'
                              v-validate="'required'"
                              is-required
                            />
                          </div>
                        </div>
                      </div>
                      <div class="column is-2"  v-if="filterType !== ''">
                        <button
                          class="button button_ibs is-rounded sm_btn"
                          @click="setFilterValue"
                        >Filtrar</button>
                      </div>

                      <!-- Buscador -->
                      <!-- <div class="column is-3">
                        <div class="field">
                          <div class="control has-icons-right">
                            <input
                              class="input is-rounded input_ibs"
                              type="text"
                              placeholder="Buscar"
                              v-model="searchText"
                              @input="searchUser"
                            >
                            <span class="icon is-right">
                              <img class="icon_search" src="@/assets/icon/search.png">
                            </span>
                          </div>
                        </div>
                      </div> -->
                      <!-- Select -->
                      <!-- <div class="column is-3">
                        <v-select
                          class="input_select"
                          label="name"
                          placeholder='Tipo de Servicio'
                          v-model="statusSelected"
                          :reduce="status => status.id"
                          :options="serviceList"
                          @input="setStatus"
                        >
                        </v-select>
                      </div> -->
                    </div>
                  </div>
                  <div class="column" :class="[userType === typePartner ? 'is-4' : 'is-12']">
                    <!-- <button
                      class="is-pulled-right button button_ibs is-rounded"
                      @click="$router.push({ name: 'nuevo-servicio' })"
                    >
                      Solicitar Servicio
                    </button> -->
                  </div>
                  <!-- Datos -->
                  <div class="column is-12" v-if="filterSelectedList.length > 0 && userType === typePartner">
                    <span class="tag"  v-for="(element, index) in filterSelectedList" :key="index">
                      <template
                        v-if="
                          Object.keys(element)[0] === 'inspection_date' ||
                          Object.keys(element)[0] === 'reception_date' ||
                          Object.keys(element)[0] === 'delivery_date' ||
                          Object.keys(element)[0] === 'payment_date' ||
                          Object.keys(element)[0] === 'billing_date' ||
                          Object.keys(element)[0] === 'send_invoice_date' ||
                          Object.keys(element)[0] === 'created_at'"
                      >
                        <strong>{{searchKeyName(Object.keys(element))}}</strong>: {{formatDate(element[Object.keys(element)[0]].start, 'DD MMMM YYYY')}} - {{formatDate(element[Object.keys(element)[0]].end, 'DD MMMM YYYY')}}
                      </template>
                      <template v-else>
                        <strong>{{searchKeyName(Object.keys(element))}}</strong>: {{getCatalogValue(Object.keys(element)[0], element[Object.keys(element)[0]])}}
                      </template>
                      <button class="delete is-small" @click="deleteFilter(Object.keys(element)[0])"></button>
                    </span>
                  </div>
                  <div class="column is-12">
                    <base-table
                      class="is-striped-2 is-fullwidth is-hoverable"
                      :columns="this.userType === this.typeCustomer ? columnsData : columnsDataPartner"
                      :data="servicesList"
                      :loading=loading
                    >
                    </base-table>
                  </div>
                   <div class="column is-12" v-if="userType === typePartner">
                    <base-pagination
                      :page="page"
                      :pages="parseInt(pages)"
                      :action="paginator"
                      :loading="loading"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <no-information/>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import currency from '@/constants/catalogs/currency'
import months from '@/constants/catalogs/months'
import paymentMethods from '@/constants/catalogs/paymentMethods'
import wayToPay from '@/constants/catalogs/wayToPay'
import customersUserType from '@/constants/catalogs/customersUserType'
import billingStatus from '@/constants/catalogs/billingStatus'
import billFor from '@/constants/catalogs/billFor'
import service from '@/constants/catalogs/services'
import mixins from '../mixins/formats'

const DEFAULT_DISPLAY_SIZE = 10

export default {
  mixins: [mixins],
  components: {
    NoInformation: () => import('@/components/content/NoInformation.vue'),
    BulmaChart: () => import('@/components/BulmaChart.vue'),
    BaseTable: () => import('@/components/Table.vue'),
    BasePagination: () => import('@/components/BasePagination.vue')
  },
  data () {
    return {
      dateGraphics: {},
      dashboard: true,
      isEmpty: 0,
      typeCustomer: 1,
      typePartner: 2,
      whoAmI: null,
      page: 1,
      pages: 1,
      total: 1,
      loading: false,
      servicesList: [],
      columnsData: [
        {
          id: 'reference',
          header: 'Referencia Interna',
          accessor: (row) => `${row.reference}`,
          link: true,
          type: 'link',
          route: (row) => ({ name: 'detalle-servicio', params: { serviceId: row.id } })
        },
        { id: 'serviceName', header: 'Servicio', class: 'is-hidden-mobile' },
        { id: 'inspection_date', header: 'Fecha de Inspección', class: 'is-hidden-mobile', accessor: (row) => moment(row.inspection_date).format('DD-MM-YYYY') },
        { id: 'container_number', header: 'No. Contenedor', class: 'column-mobile is-hidden-mobile' },
        { id: 'po_number', header: 'PO', class: 'column-mobile is-hidden-mobile' }
      ],
      columnsDataPartner: [
        {
          id: 'reference',
          header: 'Referencia Interna',
          accessor: (row) => `${row.reference}`,
          link: true,
          type: 'link',
          route: (row) => ({ name: 'detalle-servicio', params: { serviceId: row.id, customerId: row.customer_id } })
        },
        { id: 'serviceName', header: 'Servicio', class: 'is-hidden-mobile' },
        { id: 'customerName', header: 'Cliente', class: 'is-hidden-mobile' },
        { id: 'container_number', header: 'No. Contenedor', class: 'column-mobile is-hidden-mobile' },
        { id: 'po_number', header: 'PO', class: 'column-mobile is-hidden-mobile' }
      ],
      dataCustomerService: null,
      dataPartnerServices: null,
      dataCustomerServicePartner: null,
      dataCustomerServicesPercentage: null,
      lineStacked: 'bar',
      bars: 'bar',
      pieChart: 'pie',
      optionsChartLineStacked: {
        scales: {
          yAxes: [{
            stacked: true
          }]
        }
      },
      optionsChartBars: {
        scales: {
          xAxes: [{
            offset: true,
            gridLines: {
              offsetGridLines: true
            },
            stacked: true
          }],
          yAxes: [{
            offset: true,
            gridLines: {
              offsetGridLines: true
            },
            stacked: true
          }]
        }
      },
      primaryColor: '#2C7EBF',
      secondaryColor: '#58AD36',
      siteColors: [
        '#2C7EBF',
        '#58AD36',
        '#5D6990',
        '#EA92A6',
        '#EB9E23',
        '#E850E8',
        '#935ACB',
        '#A4B3C9',
        '#264653',
        '#2a9d8f',
        '#e9c46a',
        '#e76f51',
        '#e63946',
        '#3d405b',
        '#03045e',
        '#52b788',
        '#343a40',
        '#ffe5d9',
        '#dddf00',
        '#6f4518'
      ],
      startDateOfPreviousMonth: null,
      endDateOfPreviousMonth: null,
      filterSelected: null,
      filterType: '',
      filterValue: null,
      labelSelected: '',
      filterSelectedList: [],
      filterList: [
        { id: 'reference', name: 'Referencia', type: 'search' },
        { id: 'customer_id', name: 'Cliente', type: 'list' },
        { id: 'service_id', name: 'Servicio', type: 'list' },
        { id: 'po_number', name: 'Número PO', type: 'search' },
        { id: 'provider_id', name: 'Proveedor', type: 'list' },
        { id: 'container_number', name: 'No. Contenedor', type: 'search' },
        { id: 'inspection_date', name: 'Fecha De Inspección', type: 'rangedate' },
        { id: 'month_id', name: 'Mes', type: 'list' },
        { id: 'invoice_number', name: 'No. De Factura', type: 'search' },
        // { id: 'invoice_amount', name: 'Monto Factura', type: 'search' },
        { id: 'billing_status_id', name: 'Estatus', type: 'list' },
        // { id: 'man_days', name: 'Man-days', type: 'list' },
        { id: 'country_ccounting', name: 'País', type: 'search' }
      ],
      date: {
        start: new Date(),
        end: new Date()
      },
      searchText: '',
      currentValueOfTheSelect: null,
      currencyList: currency,
      paymentMethodList: paymentMethods,
      wayToPayList: wayToPay,
      monthsList: months,
      customersUserType: customersUserType,
      billingStatus: billingStatus,
      billFor: billFor,
      serviceList: service
    }
  },
  computed: {
    ...mapState({
      userType: state => state.authentication.userType
    })
  },
  methods: {
    ...mapActions(['getDashboard', 'getCustomers', 'getServices', 'getProvidersCatalog']),
    async getDataDashboard (startDate, endDate) {
      const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

      const dashInfo = await this.getDashboard({ startDate: `${startDate}`, endDate: `${endDate}` })
      if (this.userType === this.typeCustomer) {
        const labelsCustomer = []
        const valuesCustomer = []
        if (dashInfo) {
          dashInfo.anualServices.map(element => {
            labelsCustomer.push(`${months[element.month - 1]} ${element.year}`)
            valuesCustomer.push(element.total)
          })
          this.customerServicesConfiguration(labelsCustomer, valuesCustomer, 'Servicios')
          if (dashInfo.servicesTypes) {
            const labelCustomerService = []
            const valuesCustomerService = []
            dashInfo.servicesTypes.map(element => {
              labelCustomerService.push(element.name)
              valuesCustomerService.push(element.total)
            })
            this.customerServicesPercentageConfiguration(labelCustomerService, valuesCustomerService, 'Porcentaje de Servicios')
          }
        }
        this.servicesList = dashInfo.latestServices
      } else {
        const labelsPartner = []
        const valuesParter = []
        if (dashInfo) {
          dashInfo.anualServices.map(element => {
            labelsPartner.push(`${months[element.month - 1]} ${element.year}`)
            valuesParter.push(element.total)
          })
          this.partnerServicesConfiguration(labelsPartner, valuesParter, 'Servicios')
        }
        const labelsServicesCustomer = []
        const valuesServicesCustomer = []
        if (dashInfo) {
          dashInfo.customers.map(element => {
            labelsServicesCustomer.push(element.name)
            valuesServicesCustomer.push(element.total)
          })
          this.customerServicesConfigurationPartner(labelsServicesCustomer, valuesServicesCustomer, 'Clientes')
          this.servicesList = dashInfo.latestServices
        }
      }
      this.loading = false
    },
    async customerServicesConfiguration (labels, data, labelChart) {
      this.dataCustomerService = {
        labels: labels,
        datasets: [{
          backgroundColor: this.primaryColor,
          borderColor: this.primaryColor,
          pointBackgroundColor: this.primaryColor,
          data: data,
          label: labelChart
        }]
      }
    },
    async partnerServicesConfiguration (labels, data, labelChart) {
      this.dataPartnerServices = {
        labels: labels,
        datasets: [{
          backgroundColor: this.secondaryColor,
          borderColor: this.secondaryColor,
          data: data,
          label: labelChart
        }]
      }
    },
    async customerServicesConfigurationPartner (labels, data, labelChart) {
      const color = await this.definedRandomColors(data.length)
      this.dataCustomerServicePartner = {
        labels: labels,
        datasets: [{
          backgroundColor: color,
          borderWidth: 1,
          data: data,
          label: labelChart
        }]
      }
    },
    async customerServicesPercentageConfiguration (labels, data, labelChart) {
      const color = await this.definedRandomColors(data.length)
      this.dataCustomerServicesPercentage = {
        labels: labels,
        datasets: [{
          backgroundColor: color,
          borderWidth: 1,
          data: data,
          label: labelChart
        }]
      }
    },
    dynamicColors () {
      var r = Math.floor(Math.random() * 255)
      var g = Math.floor(Math.random() * 255)
      var b = Math.floor(Math.random() * 255)
      return `rgb(${r}, ${g}, ${b}, 0.8)`
    },
    scaleColors (color, size) {
      const colors = []
      for (let i = 0; i < size; i++) {
        let p = 1
        let temp = ''
        let result = '#'
        const random = Math.random()

        while (p < color.length) {
          temp = parseInt(color.slice(p, p += 2), 16)
          temp += Math.floor((255 - temp) * random)
          result += temp.toString(16).padStart(2, '0')
        }
        colors.push(result)
      }
      return colors
    },
    randomArrayColor (size) {
      const colors = []
      for (let i = 0; i < size; i++) {
        colors.push('#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6))
      }
      return colors
    },
    async definedRandomColors (size) {
      const colors = []
      const sizeArrayColors = this.siteColors.length - 1
      const sizeLimit = Math.ceil(size / this.siteColors.length)
      const limit = []
      for (let j = 1; j < sizeLimit + 1; j++) {
        limit.push(j * this.siteColors.length)
      }

      let localIndex = 0
      for (let i = 0; i < size; i++) {
        if (i > sizeArrayColors) {
          if (limit.includes(i)) {
            localIndex = 0
          } else {
            localIndex = localIndex + 1
          }
        } else {
          localIndex = i
        }
        colors.push(this.siteColors[localIndex])
      }
      return colors
    },
    getDataDashboardByDate () {
      this.loading = true
      const startDate = moment(this.dateGraphics.start).format('YYYY-MM-DD')
      const endDate = moment(this.dateGraphics.end).format('YYYY-MM-DD')
      this.getDataDashboard(startDate, endDate)
    },
    async setFilter (filterId) {
      this.showErrorFilter = false
      this.selectedFilterData = []
      console.log(filterId)
      if (filterId === null) {
        filterId = ''
        this.filterType = ''
      } else {
        switch (filterId) {
          case 'customer_id': {
            // @TODO: Validar con los filtros seleccionados
            const { success, customers } = await this.getCustomers({ page: 1, limit: 100 })
            this.selectedFilterDatacustomers = success ? customers : []
            this.selectedFilterData = success ? customers : ''
            const isPartnerSelected = this.filterSelectedList.find(element => element.partner_id)
            if (isPartnerSelected) {
              this.selectedFilterData = this.selectedFilterData.filter(customer => customer.partner_id === isPartnerSelected.partner_id)
            }
            break
          }
          case 'provider_id': {
            // @TODO: Validar con los filtros seleccionados
            const isCustomerSelected = this.filterSelectedList.find(element => element.customer_id)
            const customer = isCustomerSelected ? { customerId: isCustomerSelected.customer_id } : {}
            const { success, providers } = await this.getProvidersCatalog(customer)
            this.selectedFilterDataproviders = success ? providers : []
            this.selectedFilterData = success ? providers : ''
            break
          }
          case 'client_type': {
            this.selectedFilterData = this.customersUserType
            break
          }
          case 'currency_id': {
            this.selectedFilterData = this.currencyList
            break
          }
          case 'month_id': {
            this.selectedFilterData = this.monthsList
            break
          }
          case 'billing_status_id': {
            this.selectedFilterData = this.billingStatus
            break
          }
          case 'billing_for_id': {
            this.selectedFilterData = this.billFor
            break
          }
          case 'comision': {
            this.selectedFilterData = this.comisionList
            break
          }
          case 'man_days': {
            this.selectedFilterData = this.manDaysList
            break
          }
          case 'service_id': {
            this.selectedFilterData = this.serviceList
            break
          }
          default: break
        }
        const filterType = this.filterList.find(filter => filter.id === filterId)
        this.filterType = filterType.type
        this.labelSelected = filterType.name
      }
    },
    setFilterValue () {
      switch (this.filterType) {
        case 'search': {
          this.filterValue = this.searchText
          this.searchText = ''
          break
        }
        case 'list': {
          this.filterValue = this.currentValueOfTheSelect
          this.currentValueOfTheSelect = ''
          break
        }
        case 'rangedate': {
          this.filterValue = this.date
          this.date = null
          break
        }
        default: break
      }
      this.page = 1
      this.showErrorFilter = false
      const filterExist = this.filterSelectedList.find(filter => {
        return filter[this.filterSelected]
      })
      if (!this.filterValue) this.showErrorFilter = true
      else {
        this.loading = true
        if (!filterExist) this.filterSelectedList.push({ [this.filterSelected]: this.filterValue })
        else filterExist[this.filterSelected] = this.filterValue
        this.$router.push({ name: 'dashboard', query: { page: this.page, search: this.searchTextGlobal, status: this.statusSelected, orderBy: this.orderBy, orderType: this.orderType } })
        this.getServicesList(this.page, this.searchTextGlobal, status, this.filterSelectedList, this.orderBy, this.orderType, this.activeYear)
        this.filterType = ''
        this.filterValue = null
        this.filterSelected = ''
      }
    },
    deleteFilter (key) {
      this.filterSelectedList = this.filterSelectedList.filter(element => Object.keys(element)[0] !== key)
      this.getServicesList(this.page, this.searchTextGlobal, status, this.filterSelectedList, this.orderBy, this.orderType, this.activeYear)
    },
    searchKeyName (key) {
      const filter = this.filterList.find(element => element.id === key[0])
      return filter ? filter.name : 'N/A'
    },
    getCatalogValue (filterId, value) {
      let newValue = null
      console.log(filterId)
      switch (filterId) {
        case 'partner_id': {
          const catalogElement = this.selectedFilterDatapartner.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'service_id': {
          const catalogElement = this.serviceList.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'customer_id': {
          const catalogElement = this.selectedFilterDatacustomers.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'provider_id': {
          const catalogElement = this.selectedFilterDataproviders.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'commercial_executive_id': {
          const catalogElement = this.selectedFilterDataCommercial.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'cn_coordinator': {
          const catalogElement = this.selectedFilterDataCnCoordinator.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'mx_coordinator': {
          const catalogElement = this.selectedFilterDataMxCoordinator.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'billing_status_id': {
          const catalogElement = this.billingStatus.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'client_type': {
          const catalogElement = this.customersUserType.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'currency_id': {
          const catalogElement = this.currencyList.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'month_id': {
          const catalogElement = this.monthsList.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'billing_for_id': {
          const catalogElement = this.billFor.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'comision': {
          const catalogElement = this.comisionList.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        default:
          newValue = value
          break
      }
      return newValue
    },
    paginator (page) {
      this.page = page
      this.$router.push({ name: 'servicios', query: { page: this.page, search: this.searchText, status: this.statusSelected } })
      this.loading = true
      this.getServicesList(this.page, this.searchText, this.statusSelected)
    },
    async getServicesList (page, search, status = '', filters = [], orderBy = '', orderType = '', year = '') {
      this.loading = true
      this.getServices({ page: page, limit: DEFAULT_DISPLAY_SIZE, search: search, status: status, filters, orderBy: orderBy, orderType: orderType, year: year || '' })
        .then((resp) => {
          this.pages = resp.totalPages
          this.servicesList = resp.services
          this.loading = false
        })
    }
  },
  async beforeMount () {
    this.loading = true
    const monthBefore = await moment().subtract(1, 'months').format('MM')
    const yearOfMonthBefore = await moment().subtract(1, 'months').format('YYYY')
    const startDate = await moment([yearOfMonthBefore, monthBefore - 1])
    const endDate = await moment(startDate).endOf('month')
    this.startDateOfPreviousMonth = await moment(startDate).format('YYYY-MM-DD')
    this.endDateOfPreviousMonth = await moment(endDate).format('YYYY-MM-DD')

    await this.getDataDashboard(this.startDateOfPreviousMonth, this.endDateOfPreviousMonth)
    if (this.userType === this.typePartner) {
      await this.getServicesList(this.page, this.searchText, this.statusSelected)
    }
  }
}
</script>

<style lang="scss" scoped>
  .section {
    width: 100%;
    min-height: calc(100vh - 90px);
    padding: 0;
  }

  .box {
    min-height: 100%;
  }

  .inner-section {
    display: flex;
    justify-content: center;
  }

  .icon_table_action {
    max-width: 15px;
    margin: 5px;
  }
  .icon_small {
    max-width: 22px;
    margin: 5px;
    cursor: pointer;
  }
  .icon_table_content {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .input_calendar {
    /deep/ input {
      min-width: 210px;
    }
  }

  .max_h .chartjs {
    max-height: 400px;
    max-width: 400px;
    margin: auto;
  }
</style>
